document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".header__inline-menu details");
  menuItems.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", "true");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

var ctswiper1 = new Swiper(".banner-slider-swiper",{
  spaceBetween: 0,
  slidesPerView: 1,
  navigation: false,
  autoHeight: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".banner-slider-swiper .swiper-pagination",
    clickable: true
  },
})
var swiper2 = new Swiper(".testimonial-swiper",{
  spaceBetween: 30,
  slidesPerView: 1,
  navigation: false,
  autoHeight: true,
  pagination: false,
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 100
    },
  }
})
var swiper3 = new Swiper(".pdp-ingredient-wrp.mb_show",{
  spaceBetween: 10,
  slidesPerView: 1,
  navigation: false,
  autoHeight: true,
  pagination: {
    el: ".pdp-ingredient-wrp .swiper-pagination",
    clickable: true
  },
})

$(document).on('click', '.product-tab', function() {
  let title_handle = $(this).data('product-tab');
  console.log(title_handle);
  let parent = $(this).closest('.tab-product-list_wrp');
  parent.find('.product-tab').removeClass('active');
  $(this).addClass('active');
  parent.find('.tab_products').removeClass('active');
  parent.find('.tab_products').each(function() {   
    if ($(this).data('product-list') == title_handle) {
      $(this).addClass('active');
    }
  });
});


if(window.innerWidth < 750) {
  $(document).on('click', '.footer-block--menu .footer-block__heading', function(){
    // $('.footer-block--menu .footer-block__heading').removeClass('active');
    $(this).toggleClass('active');
    $(this).siblings('.footer-block__details-content').slideToggle();
  });
}

$(document).on('click', '.pdp-ingredient_button-open', function() {
  $('.pdp-ingredient_item_button').removeClass('active');
  $(this).parents('.pdp-ingredient_item_button').addClass('active');
});
$(document).on('click', '.pdp-ingredient_button-close', function() {
  // $('.pdp-ingredient_item_button').removeClass('active');
  $(this).parents('.pdp-ingredient_item_button').removeClass('active');
});